import { render, staticRenderFns } from "./weekTask.vue?vue&type=template&id=0a3c1c76&"
import script from "./weekTask.vue?vue&type=script&lang=js&"
export * from "./weekTask.vue?vue&type=script&lang=js&"
import style0 from "./weekTask.vue?vue&type=style&index=0&id=0a3c1c76&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports